<ng-container *ngIf="activeStep !== -1">
  <div class="progress-group-header">
    <div class="progress-group-header-left">
      <div class="progress-circle-box">
        <div class="progress-step-box">
          <div class="text-div">
            <div class="current">{{ activeStep }}/{{ totalSteps() }}</div>
          </div>
          <div [class]="'step-group step-' + activeStep + '-' + items.length">
            <svg
              class="svg-round-step"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 200 200"
            >
              <circle
                class="circle01"
                fill="none"
                cx="100"
                cy="100"
                r="92.5"
                style="stroke: rgb(203, 208, 212); stroke-width: 15"
              ></circle>
              <path
                fill="none"
                d="M 165.407362990078 34.5926084705698 A 92.5 92.5 0 0 0 100 7.5"
                style="stroke-width: 15; stroke: rgb(255, 255, 255)"
              ></path>
            </svg>
            <div class="ring">
              <div class="dot-circle dot-one"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="progress-group-header-right">
      <h3>Overall Progress</h3>
      <p>
        <a (click)="toggle()" class="link" id="progressbar-view-details"
          >View <span class="text-details">Details</span> &gt;</a
        >
      </p>
    </div>
  </div>
  <div
    class="dropdown-progress-bar-root-div"
    [ngClass]="isVisible ? 'active' : ''"
  >
    <div class="timeline-root-small">
      <div class="timeline-close-div">
        <button
          class="close-btn"
          (click)="toggle()"
          id="close-timeline-view-details"
        >
          <i class="icon-close"></i>
        </button>
      </div>
      <div class="timeline-div">
        <ul class="timeline-list">
          <li
            [ngClass]="{ active: i + 1 === activeStep }"
            *ngFor="let item of items; let i = index"
          >
            <span class="timeline-number">{{ i + 1 }}</span>
            <span class="timeline-text">
              <span class="text">{{ item }}</span>
            </span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</ng-container>
